import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// All public routes (edit/add as needed)
const PUBLIC_PATHS = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
];

function isPublicPath(pathname: string) {
  // pathname excludes query string; allow exact match or prefix match for nested routes
  return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem("access_token");
  const location = useLocation();

  // Allow all public (auth) pages for everyone
  if (isPublicPath(location.pathname)) {
    return <>{children}</>;
  }

  // No token? User is not logged in: redirect to login
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
